export const runFinishedStates = ["requires_action", "cancelled", "failed", "completed", "expired"];
